import { Space as BaseSpace } from "antd"
import React from "react"

export function Space(props: React.ComponentProps<typeof BaseSpace>) {
    return <BaseSpace {...props} />
}
